import dayjs from 'dayjs'
import { isNil } from 'lodash'

import { CertificationEntity } from '@eastcoal/api/auth/interface'

import { CERTIFICATION_DATE_STATUS } from './enum'

export const isValidCertificationDate = (data?: CertificationEntity) => {
  if (isNil(data)) {
    return CERTIFICATION_DATE_STATUS.INEFFECTIVE
  }

  const { timeType, beginTime, endTime } = data
  // 有效期类型为无限期时  该资质始终有效
  if (timeType === 1) {
    return CERTIFICATION_DATE_STATUS.EFFECTIVE
  }

  const currentDate = dayjs(dayjs())

  if (currentDate.diff(beginTime, 'day') < 0) {
    return CERTIFICATION_DATE_STATUS.INEFFECTIVE
  }

  if (currentDate.diff(endTime, 'day') > 0) {
    return CERTIFICATION_DATE_STATUS.OUTEFFECTIVE
  }

  return CERTIFICATION_DATE_STATUS.EFFECTIVE
}
